<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div actions>
    The Scroller is
    {{ (datasource.adapter.isLoading$ | async) ? 'loading' : 'relaxing' }}.
    <br />
    The value of isLoading counter has been changed for
    {{ isLoadingCounter() }} times.
  </div>
  <div description>
    <p>
      <em>Adapter.isLoading</em> is a read-only boolean property indicating
      whether there are any pending processes running by the Scroller. So when
      <em>datasource.adapter.isLoading</em> is <em>true</em>, it means that the
      Scroller is working right now and the viewport might be updated soon.
      225ms delay was added to the <em>Datasource.get</em> implementation in
      this sample.
    </p>
    <p>
      In addition to read-only scalar <em>isLoading</em> property there is also
      <em>isLoading$</em> property which is Observable. A Subject, to be exact.
      In this demo we derive a signal <em>isLoadingCounter</em> which is
      incremented each time the <em>isLoading</em> value becomes <em>false</em>.
      We see that the initial value of this counter on the UI (before any
      scrolling) is 1. So the Scroller does initialization and first 3 fetches
      in a single session.
    </p>
  </div>
</app-demo>
